import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from '../../lib/usercontext';
import AdminLayout from './adminlayout';
import CustomerLayout from './customerlayout';
import ProviderLayout from './providerlayout';
import ClientLayout from './clientlayout';
import ExternalLayout from './externallayout';

const MasterLayout = ({ children, pageTitle, searchQuery }) => {    
  const { user } = useContext(UserContext);
  const role = user.userGroups ? user.userGroups[0] : 'customer';

  useEffect(() => {
    const baseTitle = "Five Star - Senior Meals"
    document.title = pageTitle ? `${pageTitle} - ${baseTitle}` : baseTitle;
  }, [pageTitle]);    

  switch (role.toLowerCase()) {
    case 'admin':
      return <AdminLayout pageTitle={pageTitle} searchQuery={searchQuery}>{children}</AdminLayout>;
    case 'customer':
      return <CustomerLayout pageTitle={pageTitle} searchQuery={searchQuery}>{children}</CustomerLayout>;
    case 'provider':
      return <ProviderLayout pageTitle={pageTitle} searchQuery={searchQuery}>{children}</ProviderLayout>;
    case 'client':
      return <ClientLayout pageTitle={pageTitle} searchQuery={searchQuery}>{children}</ClientLayout>;        
    default:
      return <ExternalLayout pageTitle={pageTitle}>{children}</ExternalLayout>;
  }
};

MasterLayout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string,
  searchQuery: PropTypes.string,
};

export default MasterLayout;
